// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S62OE","type":"styles_type__3K4Rd","choices":"styles_choices__3yspY"};